"use client";

import { useEffect, useState } from "react";
import { fetchCommonConfig } from "@/lib/common-config-client";
import { SiteFollowUsCards } from "@/components/site/SiteFollowUsCards";

type FollowUsItem = {
  qrCode: string;
  label: string;
  account: string;
  icon: string;
  url?: string;
};

const EMPTY_FOLLOW_US_ITEMS: FollowUsItem[] = [];

export const SiteFollowUs = ({
  className,
  initialItems = EMPTY_FOLLOW_US_ITEMS,
}: {
  className?: string;
  initialItems?: FollowUsItem[];
}) => {
  const [followUsList, setFollowUsList] = useState<FollowUsItem[]>(initialItems);

  useEffect(() => {
    if (initialItems.length > 0) {
      return;
    }

    let cancelled = false;
    void fetchCommonConfig<FollowUsItem[]>("follow_us_list", { silent: true }).then((items) => {
      if (!cancelled) {
        setFollowUsList(items || []);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [initialItems.length]);

  return <SiteFollowUsCards className={className} items={followUsList} />;
}
